import _ from 'lodash'

export const ADD_KB = 'ADD_KB'
export const ADD_KB_SUCCESS = 'ADD_KB_SUCCESS'
export const ADD_KB_FAILURE = 'ADD_KB_FAILURE'
export const FETCH_KB = 'FETCH_KB'
export const FETCH_KB_SUCCESS = 'FETCH_KB_SUCCESS'
export const FETCH_ALL_KB = 'FETCH_ALL_KB'
export const FETCH_ALL_KB_SUCCESS = 'FETCH_ALL_KB_SUCCESS'
export const FETCH_KB_SECTIONS = 'FETCH_KB_SECTIONS'
export const FETCH_KB_SECTIONS_SUCCESS = 'FETCH_KB_SECTIONS_SUCCESS'
export const UPDATE_KB = 'UPDATE_KB'
export const UPDATE_KB_SUCCESS = 'UPDATE_KB_SUCCESS'
export const DELETE_KB = 'DELETE_KB'
export const DELETE_KB_SUCCESS = 'DELETE_KB_SUCCESS'
export const SYNC_KB = 'SYNC_KB'
export const SYNC_KB_SUCCESS = 'SYNC_KB_SUCCESS'
export const SHOW_KB_SETTINGS_MODAL = 'SHOW_KB_SETTINGS_MODAL'
export const SET_ACTIVE_KB = 'SET_ACTIVE_KB'

export const addKB = (payload) => ({
  type: ADD_KB,
  payload: _.pick(payload, ['kb_type', 'name', 'url', 'file'])
})

export const addKBSuccess = (payload) => ({
  type: ADD_KB_SUCCESS,
  payload
})

export const addKBFailure = (payload) => ({
  type: ADD_KB_FAILURE,
  payload
})

export const fetchAllKB = (payload) => ({
  type: FETCH_ALL_KB,
  payload
})

export const fetchAllKBSuccess = (payload) => ({
  type: FETCH_ALL_KB_SUCCESS,
  payload
})

export const fetchKBSections = (payload) => ({
  type: FETCH_KB_SECTIONS,
  payload: _.pick(payload, ['kbId'])
})

export const fetchKBSectionsSuccess = (payload) => ({
  type: FETCH_KB_SECTIONS_SUCCESS,
  payload
})

export const updateKB = (payload) => ({
  type: UPDATE_KB,
  payload: _.pick(payload, ['kbId', 'name', 'ignore_sections'])
})

export const updateKBSuccess = (payload) => ({
  type: UPDATE_KB_SUCCESS,
  payload
})

export const deleteKB = (payload) => ({
  type: DELETE_KB,
  payload: _.pick(payload, ['kbId'])
})

export const deleteKBSuccess = (payload) => ({
  type: DELETE_KB_SUCCESS,
  payload
})

export const syncKB = (payload) => ({
  type: SYNC_KB,
  payload: _.pick(payload, ['kbId'])
})

export const syncKBSuccess = (payload) => ({
  type: SYNC_KB_SUCCESS,
  payload: _.pick(payload, ['kbId'])
})

export const showKbSettingsModal = (payload) => ({
  type: SHOW_KB_SETTINGS_MODAL,
  payload: _.pick(payload, ['showModal'])
})

export const setActiveKb = (payload) => ({
  type: SET_ACTIVE_KB,
  payload: _.pick(payload, ['kb'])
})
